import DOMPurify from 'dompurify';

/**
 * Strips all HTML tags from a string, returning plain text only.
 * Used as defense-in-depth to prevent stored XSS via form inputs.
 */
export const sanitizeText = (value) => {
  if (typeof value !== 'string') return value;
  return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
};

/**
 * Recursively sanitizes all string values in an object/array.
 * Skips keys that are known to contain non-user-input data.
 */
const SKIP_KEYS = new Set([
  'password',
  'newPassword',
  'confirmPassword',
  'token',
  'idToken',
  'accessToken',
  'refreshToken',
  'Authorization',
  'imageUrl',
  'image',
  'logoUrl',
  'bannerUrl',
  'url',
]);

export const sanitizeDeep = (data, parentKey = '') => {
  if (data === null || data === undefined) return data;

  if (typeof data === 'string') {
    if (SKIP_KEYS.has(parentKey)) return data;
    return sanitizeText(data);
  }

  if (Array.isArray(data)) {
    return data.map((item) => sanitizeDeep(item, parentKey));
  }

  if (typeof data === 'object') {
    const result = {};
    for (const key of Object.keys(data)) {
      result[key] = sanitizeDeep(data[key], key);
    }
    return result;
  }

  return data;
};
